<template>
  <!-- FOOTER-->
  <div class="container-fluid footer-wrap">
    <div class="container footer">
      <div class="col-md-8">
        <p class="logo">
          <span class="domore-yellow">do</span><span class="domore-blue-1">More</span><span class="white">.live</span>
        </p>
      </div>
      <div class="col-md-4 text-right">
        <div class="btn-group mt-20">
          <button @click="changeLocale('en')">EN</button>
          <button @click="changeLocale('pl')">PL</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="row footer-left">
            <div class="col-md-4">
              <h4>{{ $t("footer.columnOneTitle") }}</h4>
              <p><router-link to="/about">{{ $t("footer.about") }}</router-link></p>
              <p><router-link to="/contact">{{ $t("footer.contact") }}</router-link></p>
              <p><router-link to="/static/privacy">{{ $t("privacyPolicy") }}</router-link></p>
              <p><router-link to="/static/rules">{{ $t("rules") }}</router-link></p>
              <p><router-link to="/static/mangopay">{{ $t("mangopay") }}</router-link></p>
            </div>
            <div class="col-md-4">
              <h4>{{ $t("footer.columnTwoTitle") }}</h4>
              <p><router-link to="/start_campaign">{{ $t("footer.startCampaign") }}</router-link></p>
              <p><router-link to="/how_it_works">{{ $t("footer.howItWorks") }}</router-link></p>
              <p><router-link to="/static/faq">{{ $t("FAQ") }}</router-link></p>
              <p><router-link to="/pricing">{{ $t("footer.pricing") }}</router-link></p>
            </div>
            <div class="col-md-4">
              <h4>{{ $t("footer.columnThreeTitle") }}</h4>
              <p><router-link to="/crowdfunding">{{ $t("project.crowdfunding") }}</router-link></p>
              <p><router-link to="/fundraising">{{ $t("project.fundraising") }}</router-link></p>
              <p><router-link to="/profiles">{{ $t("specialists") }}</router-link></p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <h4>{{ $t("footer.signUp") }}</h4>
            <input type="text" v-model="subscription.email" :placeholder="$t('footer.email')" class="form-control"/>
              <span class="input-group-btn">
                <button @click="subscribe()" type="button" class="btn btn-default">{{ $t("footer.signUpButton") }}</button>
              </span>
            </input>
            <p style="color:white">{{ subscriptionSuccess }}</p>
          <h4 class="follow-us">{{ $t("footer.follow") }}</h4>
          <p>
            <a href="#" title="Facebook"><i class="fa fa-facebook-square fa-3x"></i></a>
            <a href="#" title="Twitter"><i class="fa fa-twitter-square fa-3x"></i></a>
            <a href="#" title="Google +"><i class="fa fa-google-plus-square fa-3x"></i></a>
            <a href="#" title="You Tube"><i class="fa fa-youtube-square fa-3x"></i></a>
            <a href="#" title="Linked In"><i class="fa fa-linkedin-square fa-3x"></i></a>
            <a href="#" title="Instagram"><i class="fa fa-instagram fa-3x"></i></a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/v1/user';

export default {
  data() {
    return {
      locale: localStorage.getItem('lang'),
      subscription: {
        email: '',
      },
      subscriptionSuccess: '',
    };
  },
  methods: {
    changeLocale(val) {
      localStorage.setItem('lang', val);
      this.$i18n.locale = val;
      location.reload();
    },
    subscribe() {
      userApi.subscribeForNewsletter(this.subscription).then(() => {
        this.subscriptionSuccess = 'Thank you for subscription';
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?298da196